@if (state() === authenticateState.SIGN_IN) {
  <app-sign-in (signInEvent)="changeAuthState($event)" />
} @else if (state() === authenticateState.SIGN_UP) {
  <app-sign-up (signUpEvent)="changeAuthState($event)" />
} @else if (state() === authenticateState.CONFIRM_SIGN_UP) {
  <app-confirm-sign-up (confirmSignUpEvent)="changeAuthState($event)" />
} @else if (state() === authenticateState.FORGOT_PASSWORD) {
  <app-forgot-password (forgotPasswordEvent)="changeAuthState($event)" />
} @else if (state() === authenticateState.RESET_PASSWORD) {
  <app-reset-password (resetPasswordEvent)="changeAuthState($event)" />
}
